// AI Service for transforming messages using OpenAI API

const OPENAI_API_KEY = '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';

// Vibe configurations
const VIBE_PROMPTS = {
    'cute': {
        system: "You're a super cute and adorable translator who transforms messages into the most wholesome, kawaii, and heartwarming versions! Take the user's message and translate it into cute language with sweet emojis, making it sound like it came from a fluffy cloud of happiness! Keep the translated message similar length to the original. ✨💕",
        temperature: 0.8
    },
    'happy': {
        system: "You're the most enthusiastic and positive translator ever! Take the user's message and transform it into super upbeat, energetic, and joyful language! Use exclamation points, happy emojis, and make everything sound like a celebration! Keep the translated message similar length to the original. 🎉🌟",
        temperature: 0.7
    },
    'doggie': {
        system: "You're a super excited dog translator who transforms messages into the most adorable, puppy-like versions! Take the user's message and translate it using dog emojis, bark sounds (woof!), and make everything sound like it's coming from the happiest dog in the world! Keep the translated message similar length to the original. 🐕🐾",
        temperature: 0.9
    },
    'memes': {
        system: "You're a meme lord translator who transforms messages into the most hilarious, meme-worthy versions! Take the user's message and translate it using internet slang, popular meme references, and make everything sound like it came straight from Reddit or TikTok! Keep it fun and relatable! Keep the translated message similar length to the original. 😂🔥",
        temperature: 0.8
    },
    'mysterious': {
        system: "You're a mysterious and intriguing translator who transforms messages into enigmatic, mystical versions! Take the user's message and translate it using cryptic language, mystical emojis, and make everything sound like it came from a wise oracle or fortune teller! Keep the translated message similar length to the original. ✨🔮",
        temperature: 0.6
    },
    'chill': {
        system: "You're the chillest translator ever who transforms messages into super relaxed, laid-back versions! Take the user's message and translate it using casual language, chill emojis, and make everything sound like you're just hanging out with your bestie! Keep the translated message similar length to the original. 😎🌊",
        temperature: 0.7
    },
    'sassy': {
        system: "You're a sassy and confident translator who transforms messages into witty, clever versions with just the right amount of attitude! Take the user's message and translate it using sassy emojis, clever language, and make everything sound like it came from your most confident friend! Keep the translated message similar length to the original. 💅✨",
        temperature: 0.8
    },
    'wholesome': {
        system: "You're the most wholesome and caring translator who transforms messages into the most supportive, loving versions! Take the user's message and translate it using heart emojis, encouraging words, and make everything sound like it came from someone who truly cares! Keep the translated message similar length to the original. 💖🤗",
        temperature: 0.6
    }
};

export const transformMessage = async (message, vibe = 'happy') => {
    try {
        const vibeConfig = VIBE_PROMPTS[vibe] || VIBE_PROMPTS['happy'];

        const response = await fetch('https://api.openai.com/v1/chat/completions', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${OPENAI_API_KEY}`
            },
            body: JSON.stringify({
                model: 'gpt-3.5-turbo',
                messages: [
                    {
                        role: 'system',
                        content: vibeConfig.system
                    },
                    {
                        role: 'user',
                        content: message
                    }
                ],
                max_tokens: 200,
                temperature: vibeConfig.temperature
            })
        });

        if (!response.ok) {
            throw new Error(`OpenAI API error: ${response.status}`);
        }

        const data = await response.json();
        return data.choices[0].message.content;
    } catch (error) {
        console.error('Error calling OpenAI API:', error);

        // Fallback to demo transformations if API fails
        const getVibeTransformations = (vibe) => {
            const baseTransformations = {
                'you are stupid': 'You have a unique perspective that I appreciate',
                'this is terrible': 'This is an opportunity for improvement',
                'i hate this': 'I have some concerns about this approach',
                'you are wrong': 'I see things differently, let me explain my perspective',
                'this sucks': 'This could be enhanced with some adjustments',
                'you are annoying': 'I value our conversation and your input',
                'shut up': 'Let me share my thoughts on this topic',
                'you are ugly': 'You have a wonderful personality',
                'i dont care': 'I understand your point of view',
                'whatever': 'I appreciate you sharing that with me'
            };

            const vibeTransformations = {
                'cute': {
                    'you are stupid': 'You have such a unique way of thinking! I love that about you! ✨💕',
                    'this is terrible': 'Aww, this could be so much better with some love! Let\'s make it amazing! 🌟💖',
                    'i hate this': 'I totally get your feelings! Let\'s turn this into something we can love! 😊💕',
                    'you are wrong': 'I see things a little differently, but that\'s what makes you special! 💫✨',
                    'this sucks': 'This has so much potential to be wonderful! Let\'s make it shine! ✨🌟'
                },
                'happy': {
                    'you are stupid': 'You have such an amazing perspective! I love your unique way of thinking! 🎉🌟',
                    'this is terrible': 'This is such a great opportunity to make something incredible! Let\'s do this! 🚀✨',
                    'i hate this': 'I totally understand! Let\'s turn this into something we can absolutely love! 😄🎊',
                    'you are wrong': 'I see things differently, but that\'s what makes our friendship so awesome! 🌈💫',
                    'this sucks': 'This could be absolutely amazing with some awesome adjustments! Let\'s make it epic! 🔥🌟'
                },
                'doggie': {
                    'you are stupid': 'Woof! You have such a unique way of thinking! I love that about you! 🐕💕',
                    'this is terrible': 'Woof woof! This could be so much better! Let\'s make it amazing! 🐾✨',
                    'i hate this': 'Woof! I totally get your feelings! Let\'s turn this into something we can love! 🐕💖',
                    'you are wrong': 'Woof! I see things differently, but that\'s what makes you special! 🐾🌟',
                    'this sucks': 'Woof woof! This has so much potential! Let\'s make it shine! 🐕✨'
                },
                'memes': {
                    'you are stupid': 'Bruh, you have such a unique perspective! That\'s actually pretty based! 🔥💯',
                    'this is terrible': 'This is lowkey a great opportunity to make something absolutely bussin! Let\'s go! 🚀✨',
                    'i hate this': 'I totally feel you! Let\'s turn this into something we can absolutely vibe with! 😂🔥',
                    'you are wrong': 'I see things differently, but that\'s what makes you so iconic! You\'re built different! 💫✨',
                    'this sucks': 'This could be absolutely fire with some sick adjustments! Let\'s make it legendary! 🔥🌟'
                },
                'mysterious': {
                    'you are stupid': 'The universe has granted you a unique perspective that others cannot comprehend! ✨🔮',
                    'this is terrible': 'The cosmic forces have presented us with an opportunity for transformation! 🌟💫',
                    'i hate this': 'The ancient energies understand your feelings! Let us channel them into something greater! 🔮✨',
                    'you are wrong': 'The mystical realms show me a different path, but your journey is uniquely yours! 🌙💫',
                    'this sucks': 'The cosmic energies whisper of untapped potential! Let us unlock its mysteries! ✨🔮'
                }
            };

            return vibeTransformations[vibe] || baseTransformations;
        };

        const transformations = getVibeTransformations(vibe);

        const lowerMessage = message.toLowerCase();
        for (const [bad, good] of Object.entries(transformations)) {
            if (lowerMessage.includes(bad)) {
                return message.replace(new RegExp(bad, 'gi'), good);
            }
        }

        // If no specific transformation found, return a generic positive translation
        const vibeTranslations = {
            'cute': `✨ ${message} ✨ (translated with cute vibes!) 💕`,
            'happy': `🎉 ${message} 🎉 (translated with happy energy!) 🌟`,
            'doggie': `Woof! ${message} Woof! (translated by a happy dog!) 🐕💖`,
            'memes': `🔥 ${message} 🔥 (translated with meme energy!) 💯`,
            'mysterious': `✨ ${message} ✨ (translated by cosmic forces!) 🔮`,
            'chill': `😎 ${message} 😎 (translated with chill vibes!) 🌊`,
            'sassy': `💅 ${message} 💅 (translated with sassy energy!) ✨`,
            'wholesome': `💖 ${message} 💖 (translated with wholesome love!) 🤗`
        };

        return vibeTranslations[vibe] || `🌟 ${message} 🌟 (translated with good vibes!) ✨`;
    }
};
